import {
  CommunityEventMilestone,
  PlayerCommunityEvent,
} from '../../../state/communityJackpot.types';
import {
  getMilestoneRewards,
  checkAllMilestonesCompleted,
} from '../../../utils/jackpot';

export const isEventCompleted = (playerEvent: PlayerCommunityEvent) =>
  new Date(playerEvent.endDate) < new Date();

export const isEventEnded = (playerEvent: PlayerCommunityEvent) =>
  isEventCompleted(playerEvent) || checkAllMilestonesCompleted(playerEvent);

export const getPrevActiveMilestone = (playerEvent: PlayerCommunityEvent) => {
  const milestones = playerEvent.milestones.filter(
    ({ status }) => status === 'RewardPending' || status === 'Completed',
  );

  return milestones[milestones.length - 1];
};

export const getMilestoneWinners = ({ milestones }: PlayerCommunityEvent) =>
  milestones.length +
  milestones.reduce((accumulator, milestone) => {
    if (
      milestone.status !== 'Completed' &&
      milestone.status !== 'RewardPending'
    ) {
      return accumulator;
    }

    return accumulator + getMilestoneRewards(milestone.prizes);
  }, 0);

export const getMilestoneContributors = (
  showLastMilestoneHit: boolean,
  prevActiveMilestone?: CommunityEventMilestone,
  activeMilestone?: CommunityEventMilestone,
) =>
  showLastMilestoneHit
    ? prevActiveMilestone?.contributorsCount
    : activeMilestone?.contributorsCount;

export const getProgressHeight = (
  currentNumber: number,
  scaleStartNumber = 0,
  scaleEndNumber?: number,
): number => {
  if (scaleEndNumber == undefined) return 0;

  if (currentNumber >= scaleEndNumber) {
    return 100;
  }

  if (currentNumber <= scaleStartNumber) {
    return 0;
  }

  return (
    ((currentNumber - scaleStartNumber) / (scaleEndNumber - scaleStartNumber)) *
    100
  );
};
